<div id="loading-Animation-Container">
  <app-bouncing-balls [color]="color"></app-bouncing-balls>
  <div class="loading-text loading-progress-text" *ngIf="progressText" [style.color]="color">{{progressText}}</div>
  <div class="loading-text" [style.color]="color">
    <ng-container *ngIf="translate">{{text | phxTranslate}}</ng-container>
    <ng-container *ngIf="!translate">{{text}}</ng-container>
  </div>
</div>